import { PHISHING_USER_STATUS } from '../../domain/domainCodes.js'
/** Legacy strings for صياد — Locale/Resources.ar.resx and Admin/*. */

const shared = {
  editor: 'محرر', // Awareness.Editor
  addNew: 'إضافة جديدة', // Resources.addNew
  export: 'تحميل', // Resources.Export
  import: 'استيراد', // Resources.Import
  close: 'إغلاق',
  active: 'نشط', // Resources.IsActive
  inactive: 'غير مفعلة', // Resources.InActive
  edit: 'تعديل', // Resources.Edit
  delete: 'حذف', // Resources.Delete
}

export const templatesStrings = {
  qrHint: 'يتم إنشاء رمز مختلف لكل مستلم عند الإرسال. احتفظ بالموضع {{TrackingQr}} في محتوى البريد.',
  qrPreviewFailed: 'تعذرت معاينة رمز QR. تحقق من موضع الرمز داخل المحتوى ثم حاول مجددا.',

  actionFailed: 'تعذر إتمام العملية',
  imported: 'تم استيراد القوالب بنجاح',
  importNote: 'الملف المضغوط هو ما تصدره هذه الشاشة: مجلد لكل قالب بداخله details.json. القوالب التي يتطابق اسمها مع قالب موجود لا تستورد.',
  ...shared,
  title: 'قوالب الاصطياد', // Resources.Phishing_Templates

  columns: {
    name: 'الاسم', // Resources.Name
    language: 'اللغة', // Resources.Language
    // Renamed: the column heads a badge that already says `سهل / متوسط / صعب`
    // and a `المحتوى` beside it; the full phrases only widened the table.
    difficulty: 'المستوى', // Resources.DifficultyLevel
    payloadType: 'المحتوى', // Resources.PayloadType
    status: 'نشط', // Resources.IsActive
    /* The legacy heads these three `صورة مصغرة للبريد`, `صورة مصغرة لصفحة
       الهبوط` and `صورة مصغرة لصفحة ما بعد الاصطياد` — thirty characters to
       label a picture that is already a picture of the thing. The full names
       stay on the preview sheet, where they are read once. */
    emailImage: 'البريد', // Resources.EmailContentImage
    landingImage: 'صفحة الهبوط', // Resources.LandingPageContentImage
    afterImage: 'ما بعد الاصطياد', // Resources.AfterPhishingImage
  },

  templateImages: 'صور القالب', // Resources.TemplateImages

  /** The three stored screenshots, by their full legacy names. */
  surfaces: {
    email: 'صورة مصغرة للبريد', // Resources.EmailContentImage
    landing: 'صورة مصغرة لصفحة الهبوط', // Resources.LandingPageContentImage
    after: 'صورة مصغرة لصفحة ما بعد الاصطياد', // Resources.AfterPhishingImage
  },

  /** The same three on the preview switch, where three full names do not fit. */
  surfaceTabs: { email: 'البريد', landing: 'صفحة الهبوط', after: 'ما بعد الاصطياد' },

  surfaceNote: 'معاينة مبنية على بيانات القالب، وتستبدل بالصورة المرفوعة عند حفظها.',

  /* The language is a two-letter tag in the table — a whole `اللغة الإنجليزية`
     per row said, at length, the one bit of information the column exists for.
     The full names stay for the form, where there is room to be explicit. */
  languages: {
    ar: 'AR',
    en: 'EN',
    arFull: 'اللغة العربية', // Resources.Arabic
    enFull: 'اللغة الإنجليزية', // Resources.English
  },

  /** The template form — every label already exists above. */
  form: {
    title: 'قالب الاصطياد', // Resources.Phishing_Templates (singular subject)
    category: 'التصنيف', // Resources.Category
    /* A placeholder that repeats its own label says nothing twice. */
    categoryPlaceholder: 'اختر التصنيف',
    save: 'حفظ',
    saved: 'تم حفظ القالب بنجاح',
    required: 'الحقل مطلوب',

    /* The four steps the legacy's own template wizard uses —
       Views/PhishingTemplates/Index.cshtml. */
    steps: {
      identity: 'بيانات القالب',
      email: 'البريد',
      landing: 'صفحة الهبوط', // Resources.LandingPage
      after: 'ما بعد الاصطياد',
    },
    stepHints: {
      identity: 'التصنيف والاسم والمستوى واللغة',
      email: 'الموضوع والمحتوى والمرفقات',
      landing: 'الصفحة التي يصل إليها من ضغط الرابط',
      after: 'ما يراه بعد أن يقع في الاصطياد',
    },

    subject: 'الموضوع', // Resources.Subject
    thumbnail: 'صورة مصغرة للمحتوى', // Resources.Content_Thumbnail
    body: 'محتوى البريد', // Resources.Body
    richText: 'نص منسق', // Resources.RichText
    attachments: 'رفع مرفقات البريد الإلكتروني', // Resources.UploadEmailAttachments
    trackingImage: 'تتبع الصورة', // Resources.TrackingImage
    landingPage: 'صفحة الهبوط', // Resources.LandingPage
    captureData: 'الاحتفاظ بالبيانات', // Resources.CaptureSubmittedData
    capturePasswords: 'الاحتفاظ بكلمات المرور', // Resources.CapturePasswords
    redirectToUrl: 'إعادة توجيه إلى رابط', // Resources.RedirectToUrl
    redirectUrl: 'الانتقال إلى الرابط', // Resources.RedirectUrl
    redirectPage: 'محتوى صفحة ما بعد الوقوع في الاصطياد', // Resources.RedirectPage
    isActive: 'نشط', // Resources.IsActive
  },

  /** PhishingCampaignDifficultyLevel — Easy = 0, Normal = 1, Hard = 2. */
  difficulties: { 0: 'سهل', 1: 'متوسط', 2: 'صعب' },

  /** PhishingCampaignPayloadType — Website = 0, Attachment = 1, InformationRequest = 2. */
  payloads: { 0: 'موقع اصطياد', 1: 'مرفقات خبيثة', 2: 'طلب معلومات', 3: 'رمز QR' },

  /**
   * The content editor behind كتابة المحتوى.
   *
   * The legacy authors a template body in a plain textarea of raw HTML with no
   * preview and no way to insert a merge field except by typing it exactly.
   */
  content: {
    title: 'محتوى القالب',
    subject: 'عنوان الرسالة',
    tabs: { compose: 'تحرير', source: 'HTML', preview: 'معاينة' },
    tokens: 'حقول الدمج',
    tokenHint: 'تستبدل هذه الحقول ببيانات المستلم عند الإرسال.',
    bold: 'عريض',
    italic: 'مائل',
    underline: 'تسطير',
    heading: 'عنوان',
    bullets: 'قائمة',
    link: 'رابط',
    linkPrompt: 'الرابط',
    clear: 'إزالة التنسيق',
    save: 'حفظ',
    saved: 'تمت العملية بنجاح',
  },

  /** The merge fields the campaign engine substitutes at send time. */
  tokenList: [
    { token: '{{name}}', label: 'اسم المستلم' },
    { token: '{{email}}', label: 'البريد الإلكتروني' },
    { token: '{{department}}', label: 'الإدارة' },
    { token: '{{link}}', label: 'رابط الحملة' },
    { token: '{{date}}', label: 'التاريخ' },
  ],

  deleteConfirm: 'هل تريد حذف هذا القالب؟',
  deleted: 'تم حذف القالب بنجاح',

}

export const campaignsStrings = {
  ...shared,
  title: 'حملات الاصطياد', // Resources.PhishingCampaigns
  importTitle: 'استيراد البيانات من نظام الاصطياد القديم', // Resources.ImportOldPhishingSystemData
  importHint: 'رفع ملف قاعدة البيانات .db', // Resources.UploadDBFile
  from: 'من', // Resources.Date_From
  to: 'إلى', // Resources.Date_To
  report: 'التقرير', // Resources.Report
  refresh: 'تحديث',

  /** The one export this screen offers — the list as it is filtered, as a PDF. */
  exportPdf: 'تصدير PDF',
  exporting: 'جارٍ التصدير…',
  exported: 'تم تصدير قائمة الحملات',
  exportFailed: 'تعذر تصدير قائمة الحملات',
  exportNothing: 'لا توجد حملات لتصديرها',
  exportGeneratedOn: 'أُنشئ في',
  exportSearch: 'بحث',
  exportFunnel: 'مسار الحملات: من الإرسال إلى إدخال البيانات',
  exportByCampaign: 'النتائج لكل حملة',
  exportNoActivity: 'لم تُسجَّل أي نتائج بعد لهذه الحملات، لذا لا توجد رسوم بيانية.',
  exportEmpty: 'لا توجد حملات',

  saved: 'تم حفظ الحملة بنجاح',
  completed: {
    draft: 'تم حفظ مسودة الحملة',
    schedule: 'تمت جدولة الحملة، وستبدأ تلقائيا في الموعد المحدد.',
    activate: 'تم إطلاق الحملة، وبدأ تجهيز الإرسال.',
  },

  /* The settings screen, the engine panel and the ignored-headers panel. Each names the
     setting it was writing rather than "the operation". */
  settingsFail: {
    page: 'تعذر تحميل إعدادات الاصطياد',
    engine: 'تعذر حفظ إعدادات محرك الاصطياد',
    headers: 'تعذر حفظ ترويسات البريد المستثناة',
  },
  engineSaved: 'تم حفظ إعدادات محرك الاصطياد',
  headersSaved: 'تم حفظ ترويسات البريد المستثناة',

  /* The templates library. */
  templatesFail: {
    list: 'تعذر تحميل قوالب الاصطياد',
    load: 'تعذر تحميل هذا القالب',
    save: 'تعذر حفظ القالب',
    delete: 'تعذر حذف القالب',
    import: 'تعذر استيراد ملف القوالب',
    export: 'تعذر تصدير القوالب',
  },

  copied: 'تم نسخ الحملة بنجاح',
  deleted: 'تم حذف الحملة بنجاح',
  activated: 'تم تفعيل الحملة',
  disabled: 'تم تعطيل الحملة',
  cloneTitle: 'نسخ الحملة',
  cloneHint: 'سيتم إنشاء حملة جديدة من هذه الإعدادات. راجع المستهدفين والتوقيت قبل الإطلاق.',
  review: {
    title: 'مراجعة الحملة',
    action: 'مراجعة المستهدفين',
    edit: 'تعديل الحملة',
    draft: 'حفظ كمسودة',
    schedule: 'جدولة الحملة',
    activate: 'إطلاق الحملة',
    intent: {
      draft: 'ستبقى الحملة معطلة، ولن تتم جدولة أي رسائل.',
      schedule: 'ستبدأ هذه الحملة تلقائيا في الموعد المحدد.',
      activate: 'موعد الحملة مستحق الآن، ويمكن البدء في تجهيز الرسائل مباشرة.',
    },
    audienceTitle: 'المستهدفون',
    enrollment: 'يحتسب {existing} من المستهدفين ضمن الترخيص الحالي. عند التأكيد ستتم إضافة {new} مستخدمين. العدد المتاح قبل التأكيد: {remaining}. لا يلزم تسجيل دخول المستخدمين.',
    capacity: 'تحتاج الحملة إلى إضافة {needed} مستخدمين، والمتبقي في الترخيص {remaining} فقط. قلل عدد المستهدفين أو زد سعة الترخيص.',
    unlimited: 'غير محدود',
    contentTitle: 'الرسالة والوجهة',
    timingTitle: 'توقيت الإرسال',
    previewTemplate: 'معاينة الرسالة',
    confirmTitle: 'التأكيد النهائي للإطلاق',
    confirm: {
      schedule: 'راجعت الرسالة والوجهة والمواعيد وعدد المستلمين دون تكرار.',
      activate: 'راجعت الرسالة والوجهة وعدد المستلمين دون تكرار، وأنا مستعد لإطلاق الحملة.',
    },
    confirmRequired: 'أكمل التأكيد النهائي قبل المتابعة.',
    groupCount: 'الإدارات المحددة',
    recipientCount: 'المستلمون المؤهلون دون تكرار',
    audienceEstimate: 'يُراجع المستهدفون مجددا عند بدء الحملة. قد يتغير العدد إذا تغيرت عضوية الإدارات أو الأهلية.',
    overlap: 'يظهر الشخص الموجود في أكثر من إدارة محددة تحت إدارة واحدة ويُحسب مرة واحدة.',
    noLicense: 'لا يوجد ترخيص نشط للشركة.',
    empty: 'لا يوجد مستلمون مؤهلون. راجع الإدارات المحددة.',
    previewFailed: 'تعذر حساب المستهدفين. حاول مرة أخرى.',
    endBeforeStart: 'يجب أن تكون النهاية بعد البداية.',
    invalidEndDate: 'يجب أن تكون نهاية الحملة في المستقبل.',
    invalidSendBy: 'يجب أن يكون موعد اكتمال الإرسال بعد البداية وقبل النهاية وفي المستقبل.',
    countdown: 'تبدأ خلال',
    waiting: 'جارٍ بدء الحملة…',
    daySymbol: 'ي',
    hourSymbol: 'س',
    sendWindow: 'توزع الرسائل بالتساوي على المدة المختارة، ويعتمد وقت وصولها الفعلي على خادم البريد.',
  },
  actionFailed: 'تعذر إتمام العملية',

  /* NAMES THE OPERATION THAT FAILED, not "the operation". The screen knows which call it
     made; the server answers "حدث خطأ أثناء الحفظ" to all of them, and that told the
     reader nothing they did not already know from the button they pressed. A server
     message that carries a REASON still wins — see serverDetail in lib/i18n.js. */
  fail: {
    page: 'تعذر تحميل بيانات صفحة الحملات',
    list: 'تعذر تحميل قائمة الحملات',
    summary: 'تعذر تحميل ملخص الحملات للفترة المحددة',
    save: 'تعذر حفظ الحملة',
    copy: 'تعذر نسخ الحملة',
    delete: 'تعذر حذف الحملة',
    activate: 'تعذر تفعيل الحملة',
    disable: 'تعذر تعطيل الحملة',
  },

  /** No status is stored — these four are derived from active / started / finished. */
  states: {
    scheduled: 'مجدولة',
    running: 'جارية',
    finished: 'منتهية',
    inactive: 'معطلة',
  },

  disableTitle: 'إيقاف هذه الحملة؟',
  activateTitle: 'تشغيل هذه الحملة؟',
  disableConfirm: 'لن ترسل هذه الحملة ولن تحتسب نتائجها بعد الآن.',
  activateConfirm: 'ستعود هذه الحملة للعمل حسب تواريخها.',
  deleteWarning: 'سيحذف معها سجل المستخدمين وكل النتائج المسجلة، ولا يمكن التراجع.',

  columns: {
    name: 'الاسم', // Resources.Name
    period: 'الفترة', // Resources.Period
    sent: 'تم الإرسال', // Resources.EmailSent
    opened: 'تم فتح البريد', // Resources.EmailOpened
    clicked: 'تم فتح الرابط', // Resources.LinkClicked
    submitted: 'تم إدخال البيانات', // Resources.DataSubmitted
    reported: 'تم الإبلاغ', // Resources.Reported
    status: 'الحالة', // Resources.Status
  },

  row: {
    report: 'تقرير الاصطياد', // Resources.PhishingReport
    notifications: 'الإشعارات', // Resources.Notifications
    copy: 'نسخ', // Resources.Copy
    activate: 'تفعيل', // Resources.Activate
    disable: 'تعطيل', // Resources.Disable
  },

  /**
   * The إضافة جديدة campaign form — Views/PhishingCampaigns/Index.cshtml
   * `#edit_modal`. One modal, not a wizard; every label below is the legacy's.
   */
  form: {
    /* Section headings, and the four placeholders that used to repeat their own
       labels back at the reader. Neither exists in the legacy, which is one
       flat column of ten controls. */
    message: 'الرسالة والوجهة',
    timing: 'التوقيت',
    audience: 'المستهدفون',
    templatePlaceholder: 'اختر القالب',
    urlPlaceholder: 'اختر الرابط',
    senderPlaceholder: 'اختر بريد المرسل',
    programPlaceholder: 'بدون تسجيل تلقائي',
    name: 'الاسم', // Resources.Name
    template: 'قالب الحملة', // Resources.CampaignTemplate
    url: 'الرابط', // Resources.Url
    sender: 'بريد المرسل', // Resources.SenderEmail
    startDate: 'تاريخ البداية', // Resources.StartDate
    endDate: 'تاريخ النهاية', // Resources.EndDate
    schedule: 'جدولة إرسال الرسائل', // Resources.SendEmailsBy
    groups: 'الإدارات', // Resources.Groups
    selectAll: 'تحديد الكل', // Resources.SelectAll
    filter: 'تصفية', // Resources.Filter
    program: 'التسجيل التلقائي في برنامج تدريبي', // Resources.AutoEnrollProgram
    active: 'نشط', // Resources.IsActive
    save: 'حفظ', // Resources.Save
    required: 'الحقل مطلوب',
    previewTemplate: 'معاينة القالب',
    schedulingHint: 'توزع رسائل الحملة بالتساوي على المدة المختارة، بدءا من لحظة انطلاق الحملة.',
    /* THE OLD FIELD ASKED FOR AN INSTANT. `SendEmailsBy` is an absolute date and time, and
       the picker made the admin work out the arithmetic themselves: open a calendar, find
       the campaign's own start date, add half an hour to it, and hope the result lands
       inside the campaign window — three server rules away from a refusal.

       What the field actually decides is a DURATION: the engine spreads the whole audience
       evenly from the moment the campaign starts until this instant, so the only thing that
       ever mattered was how long that spread should be. These are the durations, and the
       drawer turns the chosen one into the instant the API wants. */
    sendWindows: [
      { value: '0', label: 'إرسال الحملة للجميع عند بدايتها' },
      { value: '15', label: 'إرسال الحملة للجميع خلال أول 15 دقيقة' },
      { value: '30', label: 'إرسال الحملة للجميع خلال أول 30 دقيقة' },
      { value: '60', label: 'إرسال الحملة للجميع خلال أول ساعة' },
      { value: '120', label: 'إرسال الحملة للجميع خلال أول ساعتين' },
      { value: '180', label: 'إرسال الحملة للجميع خلال أول 3 ساعات' },
    ],
    /* A campaign that runs for twenty minutes cannot spread its mail over three hours: the
       server refuses `SendEmailsBy` past the end date. Say which way out. */
    windowTooLong: 'المدة المختارة تتجاوز نهاية الحملة. اختر مدة أقصر أو اجعل تاريخ النهاية لاحقا.',
    /* Only reachable by opening a campaign whose stored moment matches none of the
       durations above — one made in the legacy app, or before this field changed. It is
       offered back unchanged so that editing anything else leaves the schedule alone. */
    sendWindowKept: 'الموعد المحفوظ',
    uniqueName: 'اختر اسما مختلفا للحملة الجديدة.',
  },

  deleteConfirm: 'هل تريد حذف هذه الحملة؟',
}

export const phishingSettingsStrings = {
  ...shared,
  title: 'الإعدادات', // Resources.Settings
  subtitle: 'صياد', // Resources.Phishing

  actionFailed: 'تعذر إتمام العملية',
  saved: 'تم الحفظ بنجاح',
  save: 'حفظ',
  required: 'الحقل مطلوب',

  /** The settings tab — the loose settings the legacy keeps under إعدادات الاصطياد. */
  settings: {
    panelTitle: 'إعدادات الإصطياد',
    panelSubtitle: 'إدارة أتمتة الحملات، ومستمع البلاغات، وروابط المحاكاة، وتكامل إضافة أوتلوك',
    panelInfo: 'الإعدادات المركزية لمنصة محاكاة الاصطياد: ضبط خدمات المعالجة الخلفية، وروابط إرسال المحاكاة، وإضافة الإبلاغ للموظفين.',

    servicesGroup: 'خدمات المعالجة الآلية في الخلفية',
    servicesGroupHint: 'خدمات معالجة مستمرة تعمل في خدمة Rawam Jobs لإطلاق الحملات المجدولة وسحب بلاغات الموظفين',
    deliveryGroup: 'إرسال المحاكاة وحماية النتائج',
    deliveryGroupHint: 'الرابط الافتراضي لصفحات الاصطياد وقواعد استبعاد الفحص التلقائي',
    reportingGroup: 'بلاغات الموظفين وتكامل أوتلوك',
    reportingGroupHint: 'سلوك الإبلاغ وإعادة التوجيه لصندوق الأمن وإعدادات إضافة أوتلوك',

    statusActive: 'نشط',
    statusDisabled: 'معطل',

    engine: 'محرك الاصطياد',
    engineHint: 'تشغيل إرسال حملات الاصطياد ومتابعة أحداثها',
    engineInfo: 'خدمة الخلفية المسؤولة عن تشغيل حملات الاصطياد المجدولة، وإرسال رسائل المحاكاة للموظفين عبر SMTP على دفعات، وتعيين برامج التدريب العلاجي تلقائياً عند انتهاء الحملة لمن وقع في الفخ.',
    intervalHint: 'بصيغة ساعات:دقائق:ثوان — مثال 00:00:10',
    phishingEnabled: 'تفعيل خاصية الصياد',
    phishingEnabledInfo: 'عند التفعيل، يقوم المحرك في الخلفية بمعالجة وإرسال حملات الاصطياد لهذا المشترك. تعطيله يوقف فوراً إرسال جميع رسائل المحاكاة وتنفيذ الحملات.',
    phishingInterval: 'معدل تشغيل خدمة الصياد',
    delayBeforeNextRun: 'مدة الانتظار قبل التشغيل التالي',
    phishingIntervalInfo: 'الفاصل الزمني لفحص الحملات الجاهزة للإطلاق في الخلفية، وإرسال دفعات البريد (50 رسالة كل دفعة)، وإنهاء الحملات المكتملة. الصيغة: ساعات:دقائق:ثوان.',

    listener: 'متابعة بريد البلاغات',
    listenerHint: 'قراءة صندوق البريد الذي يبلغ إليه المستخدمون عن الرسائل المشبوهة',
    listenerInfo: 'خدمة الخلفية المسؤولة عن الاتصال بصندوق بريد البلاغات عبر IMAP، واستخراج معرفات الحملات الأمنية المشفرة، وتسجيل الإبلاغ وتحديث نتائج الحملة، ومنح نقاط التفاعل التلقائية للموظف.',
    listenerEnabled: 'تفعيل خاصية قراءة البريد الإلكتروني',
    listenerEnabledInfo: 'عند التفعيل، تتصل الخدمة دورياً بملف IMAP النشط لمعالجة بلاغات الموظفين. تعطيلها يوقف الاتصال بصندوق البريد وسحب البلاغات لهذا المشترك.',
    listenerInterval: 'معدل تشغيل خدمة قراءة رسائل البريد الإلكتروني',
    listenerIntervalInfo: 'الفاصل الزمني لمحاولات الاتصال بصندوق البريد IMAP لجلب البلاغات الجديدة ومعالجتها. الصيغة: ساعات:دقائق:ثوان.',

    url: 'رابط الخدمة',
    urlHint: 'العنوان الذي تفتح منه صفحات الاصطياد وتحتسب عليه الأحداث',
    urlInfo: 'الرابط الافتراضي البديل المستخدم لتوليد روابط الاصطياد المحاكية ({{TrackingUrl}} و __URL) وصور التتبع المخفية في حال لم يتم تحديد رابط مخصص للحملة من تبويب الروابط.',
    urlFieldInfo: 'عنوان الرابط الأساسي لخدمة محاكاة الاصطياد. يؤثر على روابط التعقب المنشأة للحملات التي لا تستخدم رابطاً مخصصاً.',

    skipHeaders: 'تجاهل أو تعامل مع طلبات المستخدم التي تحتوي على البيانات التالية',
    skipHeadersHint: 'تتطابق القواعد مع اسم الترويسة وقيمتها حرفيا. الاستبعاد يمنع احتساب الطلب. عند وجود قواعد تضمين، يجب أن يطابق الطلب واحدة منها على الأقل. الاستبعاد له الأولوية.',
    skipHeadersInfo: 'حماية إحصائيات الحملات من روبوتات الحماية ومحللات الفيروسات وفحص الروابط التلقائي، حيث يتم تجاهل الطلبات المطابقة لهذه الترويسات لمنع احتسابها كضغطات موظفين.',
    skipHeadersAdd: 'إضافة جديدة',
    skipHeadersEmpty: 'لا توجد ترويسات متجاهلة',
    headerName: 'المفتاح',
    headerNameInfo: 'اسم ترويسة HTTP المستهدفة للفحص (مثل User-Agent أو X-Scanner-Scan-Id).',
    headerValue: 'القيمة',
    headerValueInfo: 'القيمة الدقيقة للترويسة المطلوب مطابقتها حرفياً مع الطلب الوارد.',
    headerType: 'النوع',
    headerTypeInfo: 'استبعاد: تجاهل الطلب تماماً وعدم احتسابه في الإحصائيات. تضمين: احتساب الطلب فقط إذا طابق قاعدة تضمين واحدة على الأقل.',
    headerExclude: 'تجاهل هذا الطلب',
    headerInclude: 'إدراج هذا الطلب',
    headerNameInvalid: 'أدخل اسم ترويسة صالحا بدون مسافات، مثل User-Agent.',
    headerValueInvalid: 'لا يمكن أن تحتوي قيمة الترويسة على أسطر جديدة أو محارف فارغة.',
    headerDuplicate: 'هذه القاعدة موجودة بالفعل.',
    headersInvalid: 'تعذر قراءة قواعد الترويسات المحفوظة. يرجى تصحيح إعداد الترويسات قبل تعديله هنا.',

    outlook: 'إضافة أوتلوك',
    outlookHint: 'كيف يبلغ المستخدم عن رسالة مشبوهة من داخل أوتلوك',
    outlookInfo: 'إعدادات تُعمم على إضافة راوم في أوتلوك لتوجيهها حول كيفية إرسال البلاغات، وصندوق استقبال نسخ .eml المشبوهة، وكيفية التعامل مع الرسالة بعد الإبلاغ.',
    outlookType: 'آلية التبليغ عبر ال Outlook',
    outlookTypeInfo: 'اختر "إرسال بريد" للإضافة التقليدية (VSTO) التي تعيد توجيه الرسائل عبر البريد، أو "واجهة الويب" لإضافة أوفيس 365 الحديثة التي ترسل البلاغات مباشرة عبر API.',
    outlookTypeEmail: 'إرسال البريد',
    outlookTypeWebApi: 'ويب',
    outlookMethod: 'طريقة الإبلاغ',
    outlookMethodInfo: 'يحفظ البلاغ في روام. عند تحديد بريد لاستقبال البلاغات يضع الخادم نسخة من الرسالة الأصلية في قائمة الإرسال إلى ذلك البريد. ينطبق ذلك على إضافتي الويب وVSTO.',
    outlookMethodBoth: 'كلاهما (تذكرة أمنية وإعادة توجيه بريد)',
    outlookMethodTicket: 'حفظ في روام وإعادة توجيه من الخادم',
    outlookMethodEmail: 'بريد فقط (إعادة توجيه لصندوق الأمن)',
    outlookEmail: 'بريد استقبال البلاغات',
    outlookEmailInfo: 'بريد اختياري لاستقبال البلاغات. يرسل خادم روام عبر إعدادات بريد الإشعارات، ويجب تشغيل خدمات الإشعارات المجدولة. اتركه فارغا لحفظ البلاغات فقط. توسم رسائل الاختبار بـ [TRAINING PHISH] والبلاغات الأخرى بـ [POTENTIAL PHISH].',
    outlookDelete: 'حذف الرسالة بعد الإبلاغ',
    outlookDeleteInfo: 'عند التفعيل، تقوم إضافة أوتلوك بنقل الرسالة المشبوهة تلقائياً من صندوق الوارد إلى سلة المحذوفات بمجرد إرسال البلاغ.',
    outlookDeleteYes: 'نعم',
    outlookDeleteNo: 'لا',
    outlookNote: 'بعد ضبط طريقة الإبلاغ أو الحذف بعد الإبلاغ لا يمكن تركهما فارغين، ويمكن تغييرهما إلى قيمة أخرى.',

    outlookStudioTitle: 'مركز نشر وتثبيت إضافة أوتلوك',
    outlookStudioSubtitle: 'حزم جاهزة للتحميل بنقرة واحدة وأدلة نشر مؤتمتة لـ Microsoft 365، و Exchange الداخلي، وأوتلوك المكتبي عبر GPO.',
    outlookStudioInfo: 'نشر إضافة راوم الرسمية للإبلاغ عن الاصطياد في منظمتك. اختر بيئة البريد أدناه للحصول على الحزم المؤتمتة وإرشادات التثبيت خطوة بخطوة.',
    downloadManifest: 'تحميل ملف التكوين (Manifest XML)',
    downloadWebBundle: 'تحميل حزمة الويب المتكاملة (.ZIP)',
    downloadVstoPackage: 'تحميل حزمة VSTO لسطح المكتب (.ZIP)',
    pluginLogoRequired: 'ارفع شعار الإبلاغ الخاص بهذه الجهة من الإعدادات قبل تنزيل ملف إضافة أوتلوك.',
    vstoInstallerRequired: 'تنزيل إصدار VSTO غير متاح حتى يجهّز الفريق الفني مُثبّتاً موقّعاً يحمل شعار هذه الجهة.',
    tabM365: 'Microsoft 365 (السحابي)',
    tabExchange: 'Exchange الداخلي (On-Premises)',
    tabVsto: 'أوتلوك المكتبي / VSTO (GPO)',
    tenantBadge: 'رمز الجهة',
    hostBadge: 'مضيف الإضافة',
    endpointBadge: 'نطاق الخدمة',
    copyCommand: 'نسخ الأمر',
    commandCopied: 'تم النسخ إلى الحافظة',
    m365Step1Title: '1. النشر المركزي عبر لوحة التحكم',
    m365Step1Desc: 'سجّل الدخول إلى لوحة إدارة Microsoft 365 (admin.microsoft.com) ثم انتقل إلى الإعدادات -> التطبيقات المتكاملة (Integrated apps).',
    m365Step2Title: '2. رفع التطبيق المخصص',
    m365Step2Desc: 'انقر على "Upload custom apps" ثم اختر "Upload manifest file (.xml) from device" وارفع ملف الـ Manifest الذي قمت بتحميله.',
    m365Step3Title: '3. تحديد المستخدمين والإتاحة',
    m365Step3Desc: 'حدد "كامل المنظمة" أو مجموعات مستخدمين محددة ثم أكمل المعالج. سيظهر زر الإبلاغ تلقائياً لدى المستخدمين في الويب وتطبيق أوتلوك خلال دقائق.',
    exchangeStep1Title: '1. تشغيل Exchange Management Shell',
    exchangeStep1Desc: 'افتح وحدة تحكم Exchange Management Shell كمسؤول على خادم البريد (Exchange 2013 SP1 أو 2016 أو 2019).',
    exchangeStep2Title: '2. تنفيذ أمر التثبيت',
    exchangeStep2Desc: 'قم بفك ضغط الحزمة وتشغيل deploy-exchange.ps1، أو نفّذ الأمر التالي مباشرة عبر PowerShell:',
    exchangeStep3Title: '3. متطلبات الاتصال والتحقق',
    exchangeStep3Desc: 'تأكد من سماح الجدار الناري لأجهزة الموظفين بالاتصال الآمن HTTPS (منفذ 443) مع خادم راوم ومضيف الإضافة.',
    vstoStep1Title: '1. التثبيت الصامت على الأجهزة',
    vstoStep1Desc: 'قم بفك ضغط حزمة VSTO. للتثبيت على جهاز فردي أو للاختبار، قم بتشغيل "install.bat" مباشرة دون الحاجة لصلاحيات مدير النظام.',
    vstoStep2Title: '2. النشر المركزي عبر Active Directory GPO',
    vstoStep2Desc: 'قم بنشر ملف "RawamPhishingReporter.msi" عبر سياسات المجموعة (GPO) أو SCCM بمعاملات التثبيت الصامت /quiet /qn.',
    vstoStep3Title: '3. ضبط مفاتيح السجل Registry',
    vstoStep3Desc: 'استورد ملف "gpo-deploy.reg" عبر تفضيلات GPO لتعيين المفاتيح تلقائياً تحت HKCU\\Software\\Rawam\\PhishingReporter.',
  },

  categoryForm: {
    add: 'تصنيف جديد',
    edit: 'تعديل التصنيف',
    enabled: 'هذا التصنيف مفعل',
    empty: 'لا توجد تصنيفات بعد',
    deleteConfirm: 'هل تريد حذف هذا التصنيف؟',
    saved: 'تم حفظ التصنيف بنجاح',
    deleted: 'تم حذف التصنيف بنجاح',
    fail: {
      list: 'تعذر تحميل التصنيفات',
      save: 'تعذر حفظ التصنيف',
      delete: 'تعذر حذف التصنيف',
      import: 'تعذر استيراد ملف التصنيفات',
      export: 'تعذر تصدير التصنيفات',
    },
  },

  domainForm: {
    add: 'رابط جديد',
    edit: 'تعديل الرابط',
    empty: 'لا توجد روابط بعد',
    deleteConfirm: 'هل تريد حذف هذا الرابط؟',
    saved: 'تم حفظ الرابط بنجاح',
    deleted: 'تم حذف الرابط بنجاح',
    fail: {
      list: 'تعذر تحميل الروابط',
      save: 'تعذر حفظ الرابط',
      delete: 'تعذر حذف الرابط',
      import: 'تعذر استيراد ملف الروابط',
      export: 'تعذر تصدير الروابط',
    },
    imported: 'تم استيراد الروابط بنجاح',
    importNote: 'ملف إكسل يحتوي على اسم الرابط وعنوانه.',
  },

  /** جهات الإرسال — إعدادات إرسال البريد. */
  smtpForm: {
    add: 'جهة إرسال جديدة',
    edit: 'تعديل جهة الإرسال',
    empty: 'لا توجد جهات إرسال بعد',
    deleteConfirm: 'هل تريد حذف جهة الإرسال هذه؟',
    imported: 'تم استيراد جهات الإرسال بنجاح',
    saved: 'تم حفظ جهة الإرسال بنجاح',
    deleted: 'تم حذف جهة الإرسال بنجاح',
    tested: 'نجح الاتصال بخادم الإرسال',
    /* One sentence per operation this panel can attempt. The server answers all of them
       with "تم الحفظ بنجاح" or "حدث خطأ أثناء الحفظ"; these say which one it was. */
    fail: {
      list: 'تعذر تحميل جهات الإرسال',
      save: 'تعذر حفظ جهة الإرسال',
      delete: 'تعذر حذف جهة الإرسال',
      test: 'فشل الاتصال بخادم الإرسال',
      import: 'تعذر استيراد ملف جهات الإرسال',
      export: 'تعذر تصدير جهات الإرسال',
    },
    importNote: 'ملف إكسل بالأعمدة: الاسم، بريد المرسل، المستضيف، رقم المنفذ، اسم المستخدم، كلمة المرور، طريقة الاتصال، نشط، اسم الإعداد، عنوان المرسل الظاهر، التحقق من شهادة الخادم. تطابق الصفوف بالاسم، وكلمة المرور الفارغة تبقي المحفوظة.',

    name: 'اسم جهة الإرسال',
    nameHint: 'الاسم الذي يظهر للمستقبل في خانة المرسل',
    settingName: 'اسم الإعداد',
    settingNameHint: 'اسم داخلي للتمييز بين الإعدادات فقط، ولا يظهر للمستقبل',
    from: 'بريد المرسل',
    fromHint: 'العنوان المستخدم فعليا في الإرسال (MAIL FROM)',
    visibleSenderAddress: 'عنوان المرسل الظاهر',
    visibleSenderAddressHint: 'ما يراه المستقبل — يترك فارغا ليكون هو بريد المرسل نفسه',

    host: 'عنوان خادم البريد',
    hostHint: 'عنوان خادم الإرسال، مثال: mail.domain.com',
    port: 'رقم المنفذ',
    portHint: 'غالبا 587 أو 465',
    username: 'اسم المستخدم',
    usernameHint: 'البريد المستخدم لتسجيل الدخول إلى الخادم',
    password: 'كلمة المرور',
    passwordHint: 'كلمة مرور البريد المستخدم',
    passwordKeptHint: 'اتركها فارغة للإبقاء على كلمة المرور المحفوظة',

    connectionMethod: 'طريقة الاتصال',
    connectionMethodHint: 'نوع التشفير المستخدم في الاتصال',
    validateCertificate: 'التحقق من شهادة الخادم',
    validateCertificateHint: 'أوقف التحقق لخادم بشهادة موقعة ذاتيا',
    certificateDefault: 'الإعداد الافتراضي',
    certificateValidate: 'تحقق من الشهادة',
    certificateSkip: 'لا تتحقق من الشهادة',
    active: 'هذه الجهة مفعلة',
    activeHint: 'الجهات المفعلة فقط تظهر عند اختيار مرسل الحملة',

    test: 'اختبار الإرسال',
    testAddress: 'البريد المستخدم للاختبار',
  },

  /** صندوق البلاغات — إعدادات الوصول إلى الرسائل. */
  imapForm: {
    add: 'صندوق بريد جديد',
    edit: 'تعديل صندوق البريد',
    empty: 'لا توجد صناديق بريد بعد',
    deleteConfirm: 'هل تريد حذف صندوق البريد هذا؟',
    saved: 'تم حفظ صندوق البريد بنجاح',
    deleted: 'تم حذف صندوق البريد بنجاح',
    tested: 'نجح فتح صندوق البريد',
    imported: 'تم استيراد صناديق البريد بنجاح',
    fail: {
      list: 'تعذر تحميل صناديق البريد',
      save: 'تعذر حفظ صندوق البريد',
      delete: 'تعذر حذف صندوق البريد',
      test: 'تعذر فتح صندوق البريد بهذه الإعدادات',
      import: 'تعذر استيراد ملف صناديق البريد',
      export: 'تعذر تصدير صناديق البريد',
    },

    host: 'عنوان خادم البريد',
    hostHint: 'عنوان خادم الوصول إلى الرسائل، مثال: mail.domain.com',
    port: 'رقم المنفذ',
    portHint: 'غالبا 993 للاتصال المشفر و143 لغيره',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    passwordHint: 'كلمة مرور البريد المستخدم',
    passwordKeptHint: 'اتركها فارغة للإبقاء على كلمة المرور المحفوظة',
    folderName: 'اسم المجلد',
    folderNameHint: 'المجلد الذي تقرأ منه البلاغات، مثال: INBOX',
    connectionMethod: 'طريقة الاتصال',
    connectionMethodHint: 'نوع التشفير المستخدم في الاتصال',

    tls: 'تفعيل التشفير',
    tlsHint: 'يستخدم مع طريقة الاتصال المختارة',
    deleteEmails: 'حذف رسائل الحملات بعد قراءتها',
    deleteEmailsHint: 'تحذف رسالة البلاغ من الصندوق بعد احتسابها',
    active: 'هذا الصندوق مفعل',
    activeHint: 'الصندوق المفعل هو الذي تقرأ منه خدمة متابعة البريد',
    singleActiveNote: 'صندوق واحد فقط يمكن أن يكون مفعلا — تفعيل هذا يوقف بقية الصناديق.',

    test: 'اختبار الاتصال',
  },

  tabs: {
    settings: 'إعدادات الاصطياد',
    categories: 'تصنيفات الاصطياد', // Resources.Phishing_Categories
    smtp: 'إعدادات إرسال البريد', // Resources.EmailSMTPSettings
    imap: 'إعدادات الوصول إلى الرسائل', // Resources.EmailIMAPSettings
    domains: 'الروابط', // Resources.Domains
  },

  categories: {
    name: 'الاسم بالعربية', // Resources.Arabic_Name_
    nameEn: 'الاسم بالإنجليزية', // Resources.English_Name_
    status: 'نشط', // Resources.IsActive
  },

  smtp: {
    senderName: 'اسم جهة الإرسال', // Resources.SenderName
    host: 'الخادم', // Resources.Used_Email_Host
    port: 'رقم المنفذ', // Resources.Port
    from: 'بريد المرسل', // Resources.From
    username: 'اسم المستخدم', // Resources.Username
    status: 'نشط', // Resources.IsActive
  },

  imap: {
    host: 'الخادم', // Resources.Used_Email_Host
    port: 'رقم المنفذ', // Resources.Port
    username: 'اسم المستخدم', // Resources.Username
    folderName: 'اسم المجلد', // Resources.FolderName
    connectionMethod: 'طريقة الاتصال', // Resources.ConnectionMethod
    deleteEmails: 'حذف الرسائل بعد التعامل معها', // Resources.Delete_Campaigns_Emails
    status: 'نشط', // Resources.IsActive
    lastSync: 'آخر قراءة',
    neverSynced: 'لم تقرأ بعد',
  },

  domains: {
    name: 'الاسم', // Resources.Name
    url: 'الرابط', // Resources.URL
  },

  deleteConfirm: 'هل تريد حذف هذا المدخل؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
}

/** تقارير الاصطياد — PhishingReport, both levels. */
export const reportStrings = {
  qrVisited: 'تم فتح وجهة QR',

  /* Lived in campaignsStrings, which this page does not import — so `S.reportFail.load`
     was undefined and the catch that was supposed to report a failed load threw instead,
     taking the whole screen down to a blank page. */
  reportFail: {
    load: 'تعذر تحميل تقرير الاصطياد',
    users: 'تعذر تحميل قائمة المستهدفين',
    export: 'تعذر تصدير تقرير الاصطياد',
  },
  recipients: 'المستلمون',
  allStatuses: 'جميع الحالات',
  history: 'الإخفاق عبر الحملات',
  historyValue: (failed, sent) => `${failed} / ${sent} (${sent ? Math.round(failed / sent * 1000) / 10 : 0}%)`,
  otherFailures: (count) => `أدخل بيانات في ${count} حملات أخرى.`,
  historyHint: 'عدد الحملات التي أدخل فيها بيانات من الحملات المرسلة، بما فيها هذه الحملة. الإدخال المتكرر يحتسب مرة واحدة لكل حملة، وتستثنى الحملات المجدولة.',
  title: 'تقارير الاصطياد',
  subtitle: 'ما فعله المستهدفون بحملات الاصطياد',
  funnel: 'المسار',
  share: 'النسب',
  shareHint: 'من إجمالي المستهدفين',
  shareOf: (count, total) => `${count} من ${total}`,
  byCampaign: 'حسب الحملة',
  backToAll: 'كل الحملات',
  exportExcel: 'تصدير إلى إكسل',
  actionFailed: 'تعذر إتمام العملية',
  noCampaigns: 'لا توجد حملات',
  noUsers: 'لا يوجد مستهدفون في هذه الحملة',
  refresh: 'تحديث',
  details: 'التفاصيل',
  userDetails: 'تفاصيل المستلم',
  timeline: 'الخط الزمني للأحداث',
  noEvents: 'لا توجد أحداث مسجلة',
  ipAddress: 'عنوان IP',
  userAgent: 'وكيل المستخدم',
  forwardedFor: 'تمت إعادة التوجيه عبر',
  metadata: 'بيانات إضافية',
  submittedFields: 'الحقول المدخلة',

  /* Said plainly because the field names mislead: the API's own counters do not mean what
     they appear to. */
  countingNote:
    'تعكس الأعداد الأنشطة المسجلة. قد يفتح المستلم الرابط ثم يبلغ عن الرسالة نفسها. لا يحذف الإبلاغ نقرات الروابط أو إدخال البيانات المسجل سابقا.',
  notRecorded: 'غير مسجل',

  stages: {
    sent: 'تم الإرسال',
    opened: 'تم فتح البريد',
    clicked: 'تم فتح الرابط',
    submitted: 'تم إدخال البيانات',
    reported: 'تم الإبلاغ',
  },

  columns: {
    campaign: 'الحملة',
    startedOn: 'تاريخ البدء',
    status: 'الحالة',
    user: 'المستهدف',
    email: 'البريد الإلكتروني',
    department: 'الإدارة',
    phished: 'مرات إدخال البيانات',
    reportedOn: 'تاريخ الإبلاغ',
    details: 'التفاصيل',
  },

  /** PhishingUserStatus — the scale the recipient rows arrive on, -1..4. */
  states: {
    '-1': 'مجدولة',
    [PHISHING_USER_STATUS.SENT]: 'تم الإرسال',
    [PHISHING_USER_STATUS.EMAIL_OPENED]: 'تم فتح البريد',
    [PHISHING_USER_STATUS.LINK_CLICKED]: 'تم فتح الرابط',
    [PHISHING_USER_STATUS.DATA_SUBMITTED]: 'تم إدخال البيانات',
    [PHISHING_USER_STATUS.USER_REPORTED]: 'تم الإبلاغ',
  },
}
